import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

const options = [
  { value: 'zh', label: '中文' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'ru', label: 'Русский' },
  { value: 'ar', label: 'العربية' },
];

export default function LanguageSwitcher({ size = 'middle' }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  return (
    <Select
      value={current}
      onChange={(val) => {
        i18n.changeLanguage(val);
        localStorage.setItem('language',val);
      }}
      options={options}
      size={size}
      style={{width:'100%',marginTop:'20px',height:'40px'}}
      dir={current === 'ar'?'rtl':'ltr'}
      dropdownStyle={{
        textAlign: current === 'ar' ? 'right' : 'left', // ✅ 文本右对齐
      }}
    />
  );
}

